import {
  WORDING_ERROR,
  COURSE_DESCRIPTION_ERROR,
  COURSE_TAGS_ERROR,
} from "constants/messages/error";

// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  wording: WORDING_ERROR,
  description: COURSE_DESCRIPTION_ERROR,
  tags: COURSE_TAGS_ERROR,
  price: "Le prix est obligatoire",
};
